import { SignupFormValues } from './signup-form-values.interface';

export const initialSignupFormValues: SignupFormValues = {
  guestCheckout: false,
  email: '',
  password: '',
  confirmPassword: '',
};